import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'formatSkillName',
  pure: true,
})
export class FormatSkillNamePipe implements PipeTransform {
  constructor(private translate: TranslateService) {}
  private readonly SKILL_NAMES: Record<string, string> = {
    communication_effectiveness: this.translate.instant('Communication'),
    student_engagement_rapport: this.translate.instant('Engagement'),
    content_accuracy_alignment: this.translate.instant('Content Accuracy'),
    instructional_clarity_structure: this.translate.instant('Instructional Clarity'),
  };

  transform(skillKey: string): string {
    if (!skillKey) {
      return '';
    }

    return this.SKILL_NAMES[skillKey] || this.snakeCaseToTitleCase(skillKey);
  }

  private snakeCaseToTitleCase(snakeCase: string): string {
    return snakeCase
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
}
